import { Vue } from 'vue-class-component';
import { Job } from '@/types/Job';
import moment, { utc } from 'moment';

class Props {
  entity: Job;
}

export default class DurationField extends Vue.with(Props) {
  private time = this.getTime();

  mounted() {
    setInterval(() => {
      this.time = this.getTime();
    }, 1000);
  }

  render() {
    return <span>{this.time}</span>;
  }

  getTime() {
    if (!this.entity.startedOn) {
      return null;
    }
    const endTime = this.entity.completedOn || undefined;
    return utc(moment(endTime).diff(this.entity.startedOn)).format('H:mm:ss');
  }
}
